<div class="max-w-md mx-auto p-6 bg-white shadow-md rounded-md" *ngIf="!showNewPrinterUI">
    <h2 class="text-2xl font-semibold text-gray-800 mb-6">{{ 'settings.title' | transloco }}</h2>

    <!-- Tema (claro / escuro / sistema) -->
    <div class="mb-6 flex items-center justify-between gap-4 pb-4 border-b border-gray-200">
      <div>
        <p class="text-sm font-medium text-gray-700">{{ 'settings.theme' | transloco }}</p>
        <p class="text-xs text-gray-500">{{ 'settings.themeHint' | transloco }}</p>
      </div>
      <app-theme-switcher></app-theme-switcher>
    </div>

    <!-- Aviso de modo somente leitura -->
    <div *ngIf="isReadOnly" class="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
      <p class="text-sm text-yellow-800">
        <i class="fas fa-lock mr-2"></i>
        {{ 'settings.readOnly' | transloco }}
      </p>
    </div>
    
    <form (ngSubmit)="onSubmit()" class="space-y-4">
      <!-- Nome da Impressora -->
      <div>
        <label for="printerName" class="block text-sm font-medium text-gray-700">
          {{ 'settings.printerName' | transloco }}
        </label>
        <input
          id="printerName"
          [(ngModel)]="printerName"
          name="printerName"
          type="text"
          [placeholder]="'settings.printerNamePlaceholder' | transloco"
          [disabled]="isReadOnly"
          [readonly]="isReadOnly"
          class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          [class.bg-gray-100]="isReadOnly"
          [class.cursor-not-allowed]="isReadOnly"
        />
      </div>
  
      <!-- Formato de Impressão -->
      <div>
        <label for="printFormat" class="block text-sm font-medium text-gray-700">
          {{ 'settings.printFormat' | transloco }}
        </label>
        <select
          id="printFormat"
          [(ngModel)]="printFormat"
          name="printFormat"
          [disabled]="isReadOnly"
          class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          [class.bg-white]="!isReadOnly"
          [class.bg-gray-100]="isReadOnly"
          [class.cursor-not-allowed]="isReadOnly"
        >
          <option *ngFor="let option of printFormatOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <!-- Ações -->
      <div class="flex items-center gap-3">
        <button
          *appHasPermission="'settings.edit'"
          type="submit"
          class="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
        >
          {{ 'common.save' | transloco }}
        </button>
        <button
          *appHasPermission="'settings.edit'"
          type="button"
          (click)="onPrintTest()"
          class="text-gray-700 border border-gray-300 bg-white py-2 px-3 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300"
        >
          {{ 'settings.printTest' | transloco }}
        </button>
      </div>
    </form>
  </div>

  <div class="max-w-5xl mx-auto p-6 bg-white shadow-md rounded-md" *ngIf="showNewPrinterUI">
    <h2 class="text-2xl font-semibold text-gray-800 mb-6">{{ 'settings.configurePrinters' | transloco }}</h2>
    
    <!-- Aviso de modo somente leitura -->
    <div *ngIf="isReadOnly" class="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
      <p class="text-sm text-yellow-800">
        <i class="fas fa-lock mr-2"></i>
        {{ 'settings.readOnly' | transloco }}
      </p>
    </div>

    <div class="space-y-4">
      <div *ngIf="isLoadingPrinters" class="text-sm text-gray-600">{{ 'settings.loadingPrinters' | transloco }}</div>
      <div *ngIf="!isLoadingPrinters && printersLoadError" class="text-sm text-red-600">{{ printersLoadError }}</div>

      <div *ngIf="!isLoadingPrinters && !printersLoadError">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <label
            class="block"
            [class.cursor-pointer]="!isReadOnly"
            [class.cursor-not-allowed]="isReadOnly"
            *ngFor="let p of printers; trackBy: trackByName"
            (click)="onPrinterCardClick(p.Name)"
          >
            <div class="border rounded-md p-4 flex items-center gap-3 transition-colors"
                 [class.hover:border-blue-400]="!isReadOnly"
                 [class.ring-2]="printerName === p.Name" 
                 [class.ring-blue-500]="printerName === p.Name"
                 [class.opacity-60]="isReadOnly"
                 [class.bg-gray-50]="isReadOnly">
              <div class="shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8 text-gray-600">
                  <path d="M6 7V3h12v4h2a2 2 0 0 1 2 2v6h-4v4H8v-4H4V9a2 2 0 0 1 2-2h0zm2-2h8v2H8V5zm0 12h8v2H8v-2zm-2-4h16V9H6v4z" />
                </svg>
              </div>
              <div class="flex-1 min-w-0">
                <div class="text-sm font-medium text-gray-800 truncate">{{ p.Name }}</div>
                <div class="mt-1">
                  <span class="inline-flex items-center px-2 py-0.5 text-xs rounded-full"
                        [ngClass]="p.IsOnline ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-700'">
                    <span class="w-2 h-2 rounded-full mr-1" [ngClass]="p.IsOnline ? 'bg-green-500' : 'bg-gray-400'"></span>
                    {{ (p.IsOnline ? 'settings.online' : 'settings.offline') | transloco }}
                  </span>
                </div>
              </div>
              <div class="pl-2">
                <input type="radio" name="printerRadio" [value]="p.Name" [(ngModel)]="printerName" [disabled]="isReadOnly" />
              </div>
            </div>
          </label>
        </div>
        <p class="text-xs text-gray-500 mt-2" *ngIf="printers?.length === 0">{{ 'settings.noPrinters' | transloco }}</p>
      </div>

      <!-- Formato de Impressão -->
      <div>
        <label for="printFormatNew" class="block text-sm font-medium text-gray-700">
          {{ 'settings.printFormat' | transloco }}
        </label>
        <select
          id="printFormatNew"
          [(ngModel)]="printFormat"
          name="printFormat"
          [disabled]="isReadOnly"
          class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          [class.bg-white]="!isReadOnly"
          [class.bg-gray-100]="isReadOnly"
          [class.cursor-not-allowed]="isReadOnly"
        >
          <option *ngFor="let option of printFormatOptions" [value]="option.value">
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="flex items-center gap-3">
        <button
          *appHasPermission="'settings.edit'"
          type="button"
          (click)="onSubmit()"
          class="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
        >
          {{ 'common.save' | transloco }}
        </button>
        <button
          *appHasPermission="'settings.edit'"
          type="button"
          (click)="onPrintTest()"
          class="text-gray-700 border border-gray-300 bg-white py-2 px-3 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300"
        >
          {{ 'settings.printTest' | transloco }}
        </button>
      </div>
    </div>
  </div>

  
  